<template>
  <h3 class="title">Segundo debate presidencial</h3>
  <p>
    Selecciona a la candidata o candidato cuya nube quieras visualizar o da
    click en el icono de inicio para regresar a la vista general.
  </p>
  <div class="controles">
    <img
      src="../assets/imgs/home.png"
      class="icono"
      @click="setSeleccion('general')"
      :style="[seleccion == 'general' ? { opacity: 1 } : { opacity: 0.4 }]"
    />
    <img
      src="../assets/imgs/circ-claudia.png"
      class="icono"
      @click="setSeleccion('claudia')"
      :style="[seleccion == 'claudia' ? { opacity: 1 } : { opacity: 0.4 }]"
    />
    <img
      src="../assets/imgs/circ-xochitl.png"
      class="icono"
      @click="setSeleccion('xochitl')"
      :style="[seleccion == 'xochitl' ? { opacity: 1 } : { opacity: 0.4 }]"
    />
    <img
      src="../assets/imgs/circ-maynez.png"
      class="icono"
      @click="setSeleccion('maynez')"
      :style="[seleccion == 'maynez' ? { opacity: 1 } : { opacity: 0.5 }]"
    />
  </div>
  <div class="nube-de-palabras">
    <WordCloud :seleccionade="seleccion" />
  </div>
  <p>
    Coloca el cursor sobre cada rectángulo de color naranja, guinda o azul para
    saber en qué consistió el ataque
  </p>
  <div class="contenedor-fichas">
    <FichaCandidate
      :datos="data_ataques.tarjetas.claudia"
      :contenedor_id="'contenedorWafleClaudia'"
      :wafle_id="'wafleClaudia'"
      :tooltip_id="'tooltipCitaClaudia'"
      :img_src="'../assets/imgs/claudia.png'"
      class="Claudia"
    />
    <FichaCandidate
      :datos="data_ataques.tarjetas.xochitl"
      :contenedor_id="'contenedorWafleXochitl'"
      :wafle_id="'wafleXochitl'"
      :tooltip_id="'tooltipCitaXochitl'"
      class="Xochitl"
    />
    <FichaCandidate
      :datos="data_ataques.tarjetas.maynez"
      :contenedor_id="'contenedorWafleMaynez'"
      :wafle_id="'wafleMaynez'"
      :tooltip_id="'tooltipCitaMaynez'"
      class="Maynez"
    />
  </div>
  <div class="metodologia">
    <p>
      <span class="met">Metodología:</span> La data se obtuvo aplicando código
      de Python a la transcripción del debate y a un registro en tiempo real de
      los ataques.
    </p>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import FichaCandidate from "./FichaCandidate.vue";
import WordCloud from "./WordCloud.vue";
import datos_ataques from "../assets/data/ataques_debate.json";

const data_ataques = ref(datos_ataques);
const seleccion = ref("general");
const nombre = ref("general");

onMounted(() => {
  //console.log(seleccion.value);
  //console.log(data_wordcloud.value);
});

function setSeleccion(candidate) {
  seleccion.value = candidate;
  //console.log(seleccion.value);
  if (seleccion.value == "claudia") {
    nombre.value = "Claudia Sheinbaum Pardo";
  } else if (seleccion.value == "xochitl") {
    nombre.value = "Xochitl Gálvez Ruiz";
  } else if (seleccion.value == "maynez") {
    nombre.value = "Jorge Álvarez Máynez";
  } else {
    nombre.value = "general";
  }
}
</script>
<style>
a:link,
a:visited,
a:hover,
a:active {
  color: #666;
  text-decoration: none;
}

.title {
  font-size: 70px;
  font-weight: 500;
  font-family: "Giorgio";
  /* background-color: pink; */
  margin-top: 0;
  margin-bottom: 5px;
}

.subtitle {
  text-align: left;
}
.contenedor-fichas {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin-top: 25px;
}
.selector {
  font-weight: bolder;
}

.controles {
  display: flex;
  width: 50%;
  margin-left: 25%;
  margin-top: 15px;
  margin-bottom: 15px;
  justify-content: space-between;
}

.icono {
  width: 100px;
}

.met {
  font-weight: bold;
  text-align: left;
}

@media (max-width: 769px) {
  .tarjeta-mapa {
    width: 80%;
  }
  .controles {
    margin-left: 4%;
    width: 90%;
    gap: 10px;
  }

  .icono {
    width: 80px;
  }
}
</style>
